export { default } from './AppointmentList';
